module.exports = __webpack_public_path__ + "img/IMG-20200809-WA0018.138ca2d6.jpg";